module.exports = __webpack_public_path__ + "static/media/happy_face_monochromatic.2fcf1863.svg";